export default {
  folders: [],
  folder: {},
  folderView: {},
  postsByFolder: [],
  morePost: true,
  isDeletePost: false,
  isLoading: false
};
